import glam from 'glamorous';
import { Colors, Sizes, BrandonGrotesque } from 'module/View/Common';

export const Wrapper = glam.div({
  flex: 1,
  height: Sizes.langTopBarHeight,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
});

export const LangLink = glam.a({
  color: Colors.mobileMenu.blue,
  fontSize: 20,
  lineHeight: '30px',
  textDecoration: 'none',
  marginLeft: Sizes.smallGutter,
  marginRight: 5,
  fontFamily: BrandonGrotesque.mediumItalic,
  fontStyle: 'normal',
  fontWeight: 'normal',
  cursor: 'pointer',
  ':hover': {
    color: Colors.mobileMenu.blueHover,
  },
});



// WEBPACK FOOTER //
// ./src/module/View/Main/LangTopBar/LangTopBar.s.ts